export default {
    state: {
        periods: [],
        loading: false,
        reloadTargets: false,
        currentEventPermissions: {},
    },
    mutations: {
        ADD_PERIODS(state, data) {
            state.periods = data
        },
        TOGGLE_LOADING(state) {
            state.loading = !state.loading
        },
        RELOAD_TARGETS(state, reload) {
            state.reloadTargets = reload
        },
        SET_CURRENT_EVENT_PERMISSIONS(state, permissions) {
            state.currentEventPermissions = permissions
        },
    },
    actions: {
        applyPeriodsFilter({ commit, dispatch }, { periods = [], userId }) {
            periods = periods.map((el) => el.value)
            if (!userId) {
                return
            }
            commit('ADD_PERIODS', periods)
            dispatch('feed/setDefaultPagination')
            commit('TOGGLE_LOADING')
            dispatch('feed/resetFeed')
            dispatch('feed/getUserFeed', { userId, periods })
        },
        setCurrentEventPermissions({ commit }, permissions) {
            commit('SET_CURRENT_EVENT_PERMISSIONS', permissions)
        },
        toggleLoading({ commit }) {
            commit('TOGGLE_LOADING')
        },
        reloadTargets({ commit }) {
            commit('RELOAD_TARGETS', true)
            setTimeout(() => {
                commit('RELOAD_TARGETS', false)
            }, 500)
        },
    },
    getters: {
        periods: (state) => state.periods,
        applyingFilter: (state) => state.loading,
    },
}
